export default __webpack_public_path__ + "static/media/startpage-mobile-min.114fd17b.jpg";